import { useQueryLead } from "libs/api/src/lib/hooks/lead/useQueryLead";
import { useContext, useEffect } from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";

import usersIcon from "../../assets/img/users-icon.svg";
import { Spinner } from "../components/atoms";
import PillTabsLayout from "../components/molecules/PillTabsLayout";
import { ActionMenuButtons } from "../components/SearchGlobal/ActionMenuButtons";
import { ShopSidebarContext } from "../components/Shop/ShopSidebar/ShopSidebarContext";
import LeadDetailsForm from "../components/UserMember/LeadDetailsForm";
import { UserMemberNotes } from "../components/UserMember/Notes/UserMemberNotes";
import Timeline from "../components/UserMember/Timeline/Timeline";
import { usePortalRoutes } from "../hooks/usePortalRoutes";
import { PageTitleProviderContext } from "../providers";
import useGymflowModels from "../store";

export const LeadProfilePage = {
  Profile: "/profile",
  Notes: "/notes",
  Timeline: "/timeline",
};
function LeadProfile() {
  const { api } = useGymflowModels();
  const { createLeadLink } = usePortalRoutes();
  const match = useRouteMatch<{ id: string }>();
  const { id: _id } = match.params;
  const id = Number(_id);

  const { data: lead, isLoading } = useQueryLead({ api, leadId: id });

  const { setPageTitle } = useContext(PageTitleProviderContext);

  useEffect(() => {
    if (lead?.firstName && lead?.lastName) {
      setPageTitle({
        title: `${lead.firstName} ${lead.lastName}`,
        iconUrl: usersIcon,
      });
    }
  }, [setPageTitle, lead?.firstName, lead?.lastName]);

  const layoutConfig = [
    {
      text: "Profile",
      path: createLeadLink(id, LeadProfilePage.Profile),
      component: <LeadDetailsForm leadId={id} />,
    },
    {
      text: "Notes",
      path: createLeadLink(id, LeadProfilePage.Notes),
      component: <UserMemberNotes leadId={id} />,
    },
    {
      text: "Timeline",
      path: createLeadLink(id, LeadProfilePage.Timeline),
      component: <Timeline leadId={id} />,
    },
  ];
  const { showShop } = useContext(ShopSidebarContext);
  if (isLoading) {
    return <Spinner />;
  }

  return (
    <Switch>
      <Route path={createLeadLink(id)}>
        <PillTabsLayout
          className="p-4 lg:p-8"
          tabs={layoutConfig}
          moreActions={<ActionMenuButtons leadId={id} showShop={showShop} />}
        />
      </Route>
    </Switch>
  );
}

export default LeadProfile;
